import React from 'react';
import Tooltip from '../../Component/Tooltip';
import {useLocale} from '../../Localization/LocaleContext';
const SelectDropDown = ({
  className,
  list,
  selected_value,
  name,
  id,
  setValue,
  default_text,
  title,
  isRequired,
  title_style,
  field_style,
  tooltip,
}) => {
  const {translate} = useLocale();
  return (
    <div className="space-y-1 w-full  ">
      {title && (
        <div className="flex items-center gap-1">
          <p
            className={[
              'text-gray-600',
              isRequired &&
                "flex-none relative after:content-['*'] after:text-red-500 after:-top-[5px] after:-right-[12px] ",
            ].join(' ')}
            style={title_style}>
            {translate(title)}
          </p>
          {tooltip && <Tooltip title={translate(title)} description={translate(tooltip)} />}
        </div>
      )}
      <select
        name={name}
        id={id}
        onChange={e => setValue(e.target.value)}
        className="form-input py-2 w-full outline-none focus:outline-none outline-none ring-0 focus:ring-0"
        style={field_style}>
        {default_text && (
          <option selected disabled>
            {translate(default_text)}
          </option>
        )}
        {list.map(li => {
          return (
            <option
              selected={
                selected_value?.value == li.value || selected_value == li.value
              }
              value={li.value}>
              {translate(li.label)}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SelectDropDown;
